import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import 'rxjs/add/operator/map';
import { ActivatedRoute, Router } from '@angular/router';
import {HttpErrorResponse} from '@angular/common/http';

interface Login {
  email: string;
  password: string;
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: []
})
export class LoginComponent implements OnInit {

  returnUrl: string;
  email = null;
  password = null;
  loged: Login;
  message: boolean;
  dismissible = true;
  alerts: any = [
    /*{
      type: 'success',
      msg: `Acceso Correcto.`
    },
    {
      type: 'info',
      msg: `This alert needs your attention, but it's not super important.`
    },*/
    {
      type: 'danger',
      msg: `Usuario o contraseña incorrecta.`
    }
  ];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService
  ) { }

  ngOnInit() {
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    this.loged = {
      email: '',
      password: ''
    };
    if (localStorage.getItem('token') && localStorage.getItem('data')) {
      this.router.navigate(['/dashboard']);
    } else {
      this.router.navigate(['/']);
    }
  }

  login(value) {
    this.message = false;
    this.email = value.email;
    this.password = value.password;
    this.authenticationService.login(this.email, this.password)
      .subscribe(
        (data) => {this.router.navigate(['/dashboard']);},
        (err: HttpErrorResponse) => {
          if (err.status === 400 && err.error.error === 'invalid_grant') {
            setTimeout(() => {
              this.message = true;
            }, 1000);
          } else if (err.status === 401 && err.error.error === 'unauthorized') {
            setTimeout(() => {
              this.message = true;
            }, 1000);
          } else {
            console.log('unknown error');
            console.log(err);
          }
        }
      )
  }

}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/login/login.component.ts